export const MAX_SELECTED_LOCATIONS = 3;
